import { render, staticRenderFns } from "./BsSelect.vue?vue&type=template&id=cc708432&scoped=true&"
import script from "./BsSelect.vue?vue&type=script&lang=js&"
export * from "./BsSelect.vue?vue&type=script&lang=js&"
import style0 from "./BsSelect.vue?vue&type=style&index=0&id=cc708432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc708432",
  null
  
)

export default component.exports